'use client';

import { ReactNode } from 'react';

interface JobTagProps {
  children: ReactNode;
  icon?: ReactNode;
  variant?: 'default' | 'primary' | 'muted';
}

export function JobTag({ children, icon, variant = 'default' }: JobTagProps) {
  const variants = {
    default: 'border-border text-muted-foreground',
    primary: 'bg-blue-500/10 text-blue-500 border-blue-500/20',
    muted: 'bg-muted/50 text-muted-foreground border-transparent',
  };

  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 text-mini font-medium rounded-md border ${variants[variant]}`}
    >
      {icon && <span className="w-3 h-3 [&>svg]:w-3 [&>svg]:h-3 flex-shrink-0">{icon}</span>}
      {children}
    </span>
  );
}

